import React from 'react'
import { colors, defaultTheme } from '../styled-components/defaultTheme'
import { createMuiTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import styled from 'styled-components'

const orange = {
  50: colors.orange,
  100: colors.orange,
  200: colors.orange,
  300: colors.orange,
  400: colors.orange,
  500: colors.orange,
  600: colors.orange,
  700: colors.orange,
  800: colors.orange,
  900: colors.orange,
  A100: colors.orange,
  A200: colors.orange,
  A400: colors.orange,
  A700: colors.orange
}

const theme = createMuiTheme({
  palette: {
    primary: orange
  },
  typography: { useNextVariants: true }
})

const styles = theme => ({
  input: {
    color: defaultTheme.textColorPrimary,
    backgroundColor: colors.veryLightGray,
    '&$focused': {
      backgroundColor: colors.veryLightGray,
      color: '#646464'
    },
    '&:hover': {
      backgroundColor: colors.veryLightGray,
      color: '#646464'
    }
  },
  label: {
    color: '#646464',
    '&$focused': {
      color: '#646464'
    }
  },
  focused: {},
  hover: {}
})

const ErrorText = styled.div`
  margin-top: 3px;
  font-size: ${props => props.theme.fontSizeExtraSmall};
  color: ${props => props.theme.colors.red};
`

const MaterialTextField = (props) => {
  const { classes } = props

  return (
    <MuiThemeProvider theme={theme}>
      <TextField
        data-material-text-field
        variant="filled"
        type={props.type}
        onChange={props.onChange}
        value={props.value}
        name={props.name}
        label={props.label}
        autoFocus={props.autoFocus}
        InputLabelProps={{
          classes: {
            root: classes.label,
            focused: classes.focused
          }
        }}
        InputProps={{
          classes: {
            root: classes.input,
            focused: classes.focused
          }
        }}
      />
      {
        props.showErrorText ? <ErrorText data-input-warning>{props.errorMessage}</ErrorText> : null
      }
    </MuiThemeProvider>
  )
}

export default withStyles(styles)(MaterialTextField)
